<app-container
	[titleTemplate]="titleTemplate"
	type="clearBorder"
	[border]="true"
>
</app-container>

<ng-template #titleTemplate>
	<div class="p-2">
		<div class="flex justify-between">
			<div class="flex items-center">
				<atomic-name-badge
					size="small"
					[firstName]="$any(client)?.firstName"
					[lastName]="$any(client)?.lastName"
					[icon]="$any(client)?.name ? ICON.BUSINESS : null"
				></atomic-name-badge>

				<div class="flex flex-col justify-items-start ml-5">
					<h5 class="mb-0 font-semibold">{{ client | clientName }}</h5>
				</div>
			</div>
			<div class="flex items-center">
				<atomic-kebab-options
					(click)="$event.stopPropagation()"
					[itemGroups]="[{ items: InvestorKebabOptions }]"
					(onSelect)="onKebabSelect(client.id, $event)"
				>
				</atomic-kebab-options>
			</div>
		</div>
	</div>
</ng-template>
